import { ConferenceType } from '@wui/im'

import { Room } from '@/shared/types/store'

type JoinAudioRoom = Pick<Room, 'isGroup' | 'mode' | 'contacts'> | null | undefined

export type InitialAudioOnJoinOptions = {
  micDisabledOnStartConferenceGroup?: boolean
  pushToTalkGroup?: boolean
  currentUserImLogin?: string | null | undefined
}

export const canUserModerateRoom = (
  room: JoinAudioRoom,
  currentUserImLogin?: string | null | undefined,
): boolean => {
  if (!room?.isGroup) return true
  if (room.mode === ConferenceType.FREE_FOR_ALL) return true
  if (room.mode === ConferenceType.MODERATED) {
    const contact = room.contacts?.find((c) => c.id === currentUserImLogin)
    return contact?.role === 'Moderator' || contact?.role === 'Owner'
  }
  return false
}

export const getInitialAudioEnabledOnJoin = (
  room: JoinAudioRoom,
  options: InitialAudioOnJoinOptions = {},
): boolean => {
  const {
    micDisabledOnStartConferenceGroup = false,
    pushToTalkGroup = false,
    currentUserImLogin,
  } = options

  if (!canUserModerateRoom(room, currentUserImLogin)) {
    return false
  }

  if (room?.isGroup && !pushToTalkGroup) {
    return !micDisabledOnStartConferenceGroup
  }

  return true
}
